// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"44b376aa","306":"a92e23e7","691":"8f7be8e9","912":"201f320d"}[chunkId] + ".chunk.css";
};